import React, { useState, useEffect } from 'react';
import { Container, SectionProjeto, SectionPizza, SectionBarra, ThisCard, ThisCardItem, ThisCardTicket, ThisProgress } from './styles';

// import IconPizza from '~/assets/icones/IconPizza.svg';
import IconBarra from '~/assets/icones/IconBarra.svg';
import IconSuporte from '~/assets/icones/IconSuporte.svg';
import IconRel1 from '~/assets/icones/icone-rel-1.svg';
import IconRel2 from '~/assets/icones/icone-rel-2.svg';
import IconRel3 from '~/assets/icones/icone-rel-3.svg';
import IconRel4 from '~/assets/icones/icone-rel-4.svg';
import IconRel5 from '~/assets/icones/icone-rel-5.svg';
import IconRel1B from '~/assets/icones/icone-rel-1B.svg';
import IconRel2B from '~/assets/icones/icone-rel-2B.svg';
import IconRel3B from '~/assets/icones/icone-rel-3B.svg';
import IconRel4B from '~/assets/icones/icone-rel-4B.svg';
import IconRel5B from '~/assets/icones/icone-rel-5B.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [tickets, setTicket] = useState({});
  
  useEffect(() => {
    let itemTicket = {
      dados: [
        { 
          id: 1,
          cliente: 'Locomotiva', 
          setor: 'SRP',
          ativo: false, 
          itens: [
            {
              codigo: '#22503', 
              titulo: 'Pedido de compra com SC - Erro', 
            },
            {
              codigo: '#22503',
              titulo: 'Pedido de compra com SC - Erro',
            },
            { 
              codigo: '#22503',
              titulo: 'Pedido de compra com SC - Erro',
            },
          ],
        },
        { 
          id: 2,
          cliente: 'ACER', 
          setor: 'SRP',
          ativo: false, 
          itens: [
            {
              codigo: '#22503', 
              titulo: 'Pedido de compra com SC - Erro', 
            },
            {
              codigo: '#22503',
              titulo: 'Pedido de compra com SC - Erro',
            },
            { 
              codigo: '#22503',
              titulo: 'Pedido de compra com SC - Erro',
            },
          ],
        },
        { 
          id: 3,
          cliente: 'SOMOS', 
          setor: 'SRP',
          ativo: false, 
          itens: [
            {
              codigo: '#22503', 
              titulo: 'Pedido de compra com SC - Erro', 
            },
            {
              codigo: '#22503',
              titulo: 'Pedido de compra com SC - Erro',
            },
            { 
              codigo: '#22503',
              titulo: 'Pedido de compra com SC - Erro',
            },
          ],
        },
      ],
    };
    setTicket(itemTicket);
  }, []);

  return (
    <Container>
      <div className='sessao-quantidade'>
        {data[0]?.etapas?.map((thisData, i) => (
          <div className='item-quantidade'>
            <div className='item-header'>
              <div className='item-icon'>
                {
                  i % 5 == 0 ? (
                    <img src={localStorage.getItem("tema") == "E" ? IconRel5 : IconRel5B} alt="IconRel5" />
                  ) : i % 4 == 0 ? (
                    <img src={localStorage.getItem("tema") == "E" ? IconRel4 : IconRel4B} alt="IconRel4" />
                  ) : i % 3 == 0 ? (
                    <img src={localStorage.getItem("tema") == "E" ? IconRel3 : IconRel3B} alt="IconRel3" />
                  ) : i % 2 == 0 ? (
                    <img src={localStorage.getItem("tema") == "E" ? IconRel2 : IconRel2B} alt="IconRel2" />
                  ) : i % 1 == 0 ? (
                    <img src={localStorage.getItem("tema") == "E" ? IconRel1 : IconRel1B} alt="IconRel1" />
                  ) : (<div></div>)
                }
              </div>
              <div className='item-numero'>
                {
                  i % 5 == 0 ? (
                    <h5 className='color5'>{thisData?.quantidade}</h5>
                  ) : i % 4 == 0 ? (
                    <h5 className='color4'>{thisData?.quantidade}</h5>
                  ) : i % 3 == 0 ? (
                    <h5 className='color3'>{thisData?.quantidade}</h5>
                  ) : i % 2 == 0 ? (
                    <h5 className='color2'>{thisData?.quantidade}</h5>
                  ) : i % 1 == 0 ? (
                    <h5 className='color1'>{thisData?.quantidade}</h5>
                  ) : (<h5></h5>)
                }
              </div>
            </div>
            <div className='item-body'>
              {
                i % 5 == 0 ? (
                  <h5 className='pre-titulo-body color5'>Projetos</h5>
                ) : i % 4 == 0 ? (
                  <h5 className='pre-titulo-body color4'>Projetos</h5>
                ) : i % 3 == 0 ? (
                  <h5 className='pre-titulo-body color3'>Projetos</h5>
                ) : i % 2 == 0 ? (
                  <h5 className='pre-titulo-body color2'>Projetos</h5>
                ) : i % 1 == 0 ? (
                  <h5 className='pre-titulo-body color1'>Projetos</h5>
                ) : (<h5></h5>)
              }
              <h5 className='titulo-body'>{thisData?.titulo}</h5>
            </div>
          </div>
        ))}
      </div>
      <SectionPizza>
        <div className="div-icone">
          {/* <img src={IconPizza} alt={"IconPizza"} /> */}
          <h4 className="title">Pizza</h4>
        </div>
        <div>
          <div id="chart">
          {/* <Chart
            type='pie'
            data={{
              labels: ['Red','Blue','Yellow'],
              datasets: [{
                label: 'My First Dataset',
                data: [300, 50, 100],
                backgroundColor: ['#9747FF','#339C89','#99396D'],
                borderColor: '#2A292A',
                hoverOffset: 4
              }]
            }}
          /> */}
          {/* <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={350} /> */}
          </div>
          <div id="html-dist"></div>
        </div>
         {/* <div className="grafico-pizza"></div> */}
      </SectionPizza>
      <SectionBarra>
        <div className="div-icone">
          <img src={IconBarra} alt={"IconBarra"} />
          <h4 className="title">Barras</h4>
        </div>
        <div>
          {/* <div id="chart">
            <CChartBar
              type="bar"
              data={{
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [
                  {
                    backgroundColor: '#339C89',
                    data: [40, 20, 12, 39, 10, 40, 39, 80, 40],
                    borderRadius: 10,
                  },
                ],
              }}
              labels="months"
              options={{
                plugins: {
                  legend: {
                    display:  false,
                    labels: {
                      color: "#B1B1B1",
                    }
                  }
                },
                scales: {
                  x: {
                    grid: {
                      color: "#2A292A",
                    },
                    ticks: {
                      color: "#848688",
                    },
                  },
                  y: {
                    grid: {
                      color: "#4F4E4E",
                    },
                    ticks: {
                      color: "#848688",
                    },
                  },
                },
              }}
            />
          </div> */}
          <div id="html-dist"></div>
        </div>
        {/* <div className="grafico-pizza"></div> */}
      </SectionBarra>
      <SectionProjeto>
        <div className="div-icone">
          <img src={IconSuporte} alt={"IconSuporte"} />
          <h4 className="title">Tickets</h4>
        </div>
        {tickets?.dados?.map((thisCont, i) => (  
          <div className="card">
            <ThisCard
              onClick={() => {
                let dados = [];
                for (const item of tickets?.dados) {
                  if (thisCont?.id == item?.id) {
                    dados.push({ ...item, ativo: !item?.ativo });
                  } else {
                    dados.push({ ...item, ativo: item?.ativo });
                  }
                }

                let itemTicket = {
                  dados,
                };

                setTicket(itemTicket);
              }}
            >
              <div className="top">
                <div className="content-top">
                  <div className="card-top">
                    <p className="titulo">{thisCont?.cliente}</p>
                    <p className="analista">{thisCont?.setor}</p>
                  </div>
                </div>
                <div className="content-progress">
                  <div className="card-content">
                    <p className="titulo">70%</p>
                    <div className="progress">
                      <ThisProgress backgound="#9747FF" width={ 40 + "%"} />
                    </div>
                  </div>
                </div>
              </div> 
            </ThisCard>
            <div className={thisCont?.ativo ? 'item' : ''}>
              {thisCont?.ativo && thisCont?.itens?.map((thisTicket, l) => (                
                <ThisCardItem>
                  <div className="barra"></div>
                  <div className="top">
                    <div className="content-top">
                      <div className="card-top">
                        <p className="titulo">{thisTicket?.titulo}</p>
                        <p className="analista">{thisTicket?.codigo}</p>
                      </div>
                    </div>
                    <div className="content-progress">
                      <div className="card-content">
                        <p className="titulo">70%</p>
                        <div className="progress">
                          <ThisProgress backgound="#99396D" width={ 35 + "%"} />
                        </div>
                      </div>
                    </div>
                  </div> 
                </ThisCardItem>
              ))}
            </div>
          </div>
        ))}
      </SectionProjeto>
    </Container>
  );
}

export default CustomBodyContent;
